import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import { ActivatedRoute, Router } from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {DialogService} from "../services/dialog.service";
import {newId} from "@ng-select/ng-select/lib/id";

@Component({
  selector: 'micro-global-value-control',
  templateUrl: './global-value-control.component.html'
})
export class GlobalValueControlComponent implements OnInit, OnDestroy {

  @Input()
  controlType: string;
  @Input()
  controlName: string;
  @Input()
  valuePlaceholder: string;
  @Input()
  valueNote: string;
  @Input()
  descriptionPlaceholder: string;
  @Input()
  descriptionNote: string;
  @Input()
  descriptionOptional: boolean;
  @Input()
  confirmMessage: string;
  @Input()
  confirmButtonText: string;

  timer:any;

  log:any[];
  latest:any;
  control:  {
    controlType: string | undefined,
    controlValue: string | undefined,
    description: string | undefined
  }

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private dialogService:DialogService,
              private authService:AuthService,
              private alertService:AlertService) {
  }

  ngOnInit() {

    this.reload();

    this.timer = setInterval(()=> {
      this.reload();
    }, 30000);
  }

  reload() {
    let params:HttpParams = new HttpParams();

    params = params.set("controlType", this.controlType)
        .set("all", "true")
        .set("page", '' + (this.paginator.pageIndex || 0))
        .set("size", '' + (this.paginator.pageSize || 100));

    this.http.get(`${this.env.e.url}/domain/global/control`, {params: params}).subscribe(
      data => {
        this.log = data as any[];
        if (this.log.length && this.anyChanges(this.latest, this.log[0])) {
          this.latest = this.log[0];
          this.control = {
            controlType: this.controlType,
            controlValue: this.latest.controlValue,
            description: this.latest.description,
          };
        } else if (!this.control) {
          this.control = {
            controlType: this.controlType,
            controlValue: "",
            description: "",
          };
        }
      }
    );
  }

  updateValue() {
    if (!this.anyChanges(this.control, this.latest)) return;

    this.dialogService.confirm("Confirm", this.confirmMessage, this.confirmButtonText).subscribe(confirmed => {
        if (confirmed) {
          this.http.put(`${this.env.e.url}/domain/global/control`, this.control)
            .subscribe(
              data => {
                this.log.unshift(data);
                this.latest = data;
                this.reload();
                this.alertService.info(`${this.controlName} updated.`);
              }
            );
        }
      });
  }

  anyChanges(newControl:any, oldControl: any) {
    if (!newControl && !oldControl) return false;
    if (!newControl) return false;
    if (newControl && (!newControl.controlValue.trim() || !(newControl.description.trim() || this.descriptionOptional))) return false;
    return newControl?.controlValue?.trim() !== oldControl?.controlValue?.trim()
      || newControl?.description?.trim() !== oldControl?.description?.trim();
  }

  ngOnDestroy() {
    clearInterval(this.timer);
  }
}
